import React from 'react';
import { motion } from 'framer-motion';
import { Star, CheckCircle } from 'lucide-react';
const testimonials = [{
  name: 'Sarah M.',
  quote: "I work at a desk all day and my neck was constantly stiff. This device gave me relief the very first time I used it. It's a game changer.",
  verified: true
}, {
  name: 'James T.',
  quote: 'Better than going to the chiropractor every week. I use it while watching TV and my posture has improved significantly.',
  verified: true
}, {
  name: 'Linda R.',
  quote: 'I was skeptical, but the gentle stretch is exactly what my pinched nerve needed. Highly recommend to anyone with chronic neck pain.',
  verified: true
}];
export function SocialProof() {
  return <section className="bg-brand-purple-light py-16 lg:py-24 px-4 sm:px-6 lg:px-8" data-id="element-139">
      <div className="max-w-7xl mx-auto" data-id="element-140">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-141">
          <div className="flex justify-center gap-1 mb-3" data-id="element-142">
            {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-6 h-6 fill-yellow-400 text-yellow-400" data-id="element-143" />)}
          </div>
          <h2 className="text-2xl sm:text-3xl font-bold text-brand-black mb-2" data-id="element-144">
            4.8/5 Average Rating
          </h2>
          <p className="text-brand-gray-dark" data-id="element-145">
            Based on 1,000+ happy customers
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8" data-id="element-146">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-brand-gray-light" data-id="element-147">
              <div className="flex gap-1 mb-4" data-id="element-148">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-149" />)}
              </div>
              <p className="text-brand-black italic mb-6" data-id="element-150">"{t.quote}"</p>
              <div className="flex items-center gap-2" data-id="element-151">
                <span className="font-bold text-brand-black" data-id="element-152">{t.name}</span>
                {t.verified && <span className="flex items-center text-xs text-green-600 font-medium" data-id="element-153">
                    <CheckCircle className="w-3 h-3 mr-1" data-id="element-154" /> Verified Buyer
                  </span>}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}